{
 document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".proSlider", {
    slidesPerView: "auto",
    spaceBetween: 60,
    // centeredSlides: true,
    // loop: true,
    // autoplay: {
    //   delay: 1500,
    //   disableOnInteraction: false,
    // },
    freeMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      150: {
        spaceBetween: 10,
      },
      576: {
        spaceBetween: 20,
      },
      769: {
        spaceBetween: 30,
      },
      1026: {
        spaceBetween: 60,
      },
    },
  });
});

}
// {
//   var swiper = new Swiper(".proSlider", {
//     slidesPerView: "auto",
//     spaceBetween: 60,
//     centeredSlides: true,
//     loop: true,
//     autoplay: {
//       delay: 2500,
//       disableOnInteraction: false,
//     },
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//       dynamicBullets: true,
//     },
//     breakpoints: {
//       150: {
//         spaceBetween: 10,
//       },
//       576: {
//         spaceBetween: 20,
//       },
//       769: {
//         spaceBetween: 30,
//       },
//       1026: {
//         spaceBetween: 60,
//       },
//     },
//   });
// }

{
  var swiper = new Swiper(".feaProdSlider", {
    slidesPerView: 2,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      150: {
        slidesPerView: 1.4,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1026: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  });
}
{
  var swiper = new Swiper(".bestSLRSlid", {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      150: {
        slidesPerView: 1.4,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1026: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}

{
  var swiper = new Swiper(".testiSlider", {
    slidesPerView: 4,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      150: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 2.3,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1026: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });
}
{
  var swiper = new Swiper(".instaSlider", {
    slidesPerView: 4,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      150: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1026: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
}
{
  var swiper = new Swiper(".Sop_coll", {
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      150: {
        slidesPerView: 1.4,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 2.5,
        spaceBetween: 30,
      },
      1026: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}
